import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useQuoteState } from "./quoteState";
import { filterProductTags, textById } from '../utils';
// import { Modal } from "../../modal/Modal";

export const AddToQuote = ({ quoteQuantity, buttonWidth }) => {

  const productFormRef = useRef(null);
  const infiniteContainerRef = useRef(null);
  const breadcrumbItemsRef = useRef(null);

  const { addItem, updateItem, items, totalPrice, setShowMiniQuote } = useQuoteState();
  
  // State and "product" are initialized with global variables set in theme.liquid
  const [variant, setVariant] = useState(initialVariant);

  const product = currentProduct;
  const quoteId = localStorage.getItem("quoteId");

  const itemQuantity = Number.isInteger(quoteQuantity)
    ? parseInt(quoteQuantity)
    : parseInt(productFormRef.current?.querySelector('.quantity-selector__value')?.value) || 1;

  const updateVariant = useCallback((e) => {
    const nextVariant = e.detail.variant;
    setVariant(nextVariant);
  }, []);
  
  useEffect(() => {
    productFormRef.current = document.querySelector('.product-form');
    infiniteContainerRef.current = productFormRef.current?.querySelector('#infiniteoptions-container') ?? null;
    breadcrumbItemsRef.current = document.querySelectorAll('.breadcrumb__list .breadcrumb__item');
    window.addEventListener('variant:changed', updateVariant);
    return () => {
      window.removeEventListener('variant:changed', updateVariant);
    };
  }, [updateVariant]);
   
  const handleAddToQuote = useCallback((e) => {
    e.preventDefault();
    
    const priceRegex = /(\d{1,3}(?:\,))?\d{1,3}(?:\.\d{2})?/;
    const productForm = productFormRef.current;
    const quantityElement = productForm?.querySelector('.quantity-selector__value');
    const itemQuantity = Number.isInteger(quoteQuantity) ? parseInt(quoteQuantity) : parseInt(quantityElement?.value) || 1;

    let variantPriceElement = productForm?.querySelector('.price-list .price');
    let variantPriceMatch = variantPriceElement.innerHTML.match(priceRegex);
    let variantPrice = (variantPriceMatch) ? parseFloat(variantPriceMatch[0].replace(",", "")) * 100 : 0;

    // NEW ITEMS
    let { sku, compare_at_price, option1, option2, option3 } = variant;
    // console.log('variant', variant);
    // const shopify_options = variant.options;
    const base_price = variant.price;
    
    // Get the crating fee
    // const textById = (id) => document.getElementById(id)?.textContent ?? undefined;
    const cratingFee = textById('crating_fee');
    const cratingFeeVariant = textById('crating_fee_variant');
    const frFabricFee = textById('fr_fabric_fee_variant_id');

    let options = [];
    let optionsKey = "";
    const leadTime = textById('product-lead-time');
    if (leadTime) {
      options.push({
        key: '_LeadTime',
        label: '_Lead Time',
        value: leadTime
      });
    }

    const infiniteContainer = infiniteContainerRef.current ?? productForm?.querySelector('#infiniteoptions-container') ?? null;
    const infiniteInputsSelected = infiniteContainer?.querySelectorAll('select:not(:disabled), input:not([type=hidden]):checked, input[type=hidden], input[type="text"]') ?? [];
    
    

    // Get all the infinite options data from the infinite options container
    infiniteInputsSelected.forEach(input => {
      if (!input.name || !input.value) return;
      let key = input.name.replace("properties[", "").replace("]","");
      let value = input.value.replace(/\s*(\(\+\d+\)|\+\$?\d+)/, '');
      let label = key.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
      // label = label.replace(/\s*\+.*$/, '');
      options.push({ key, label, value });
      // console.log('options', options, 'key', key, 'label', label, 'value', value);
      optionsKey += value;
    });
    optionsKey = optionsKey.replace(/\s/g, "");


    

    // Check if the Square Footage field is empty and show an alert if it is
    const infiniteSquareFeetInput = infiniteContainer?.querySelector('input[type="text"][name="properties[square_footage]"]');
    if (infiniteSquareFeetInput && !infiniteSquareFeetInput.value.trim()) {
      window.Shoppad.apps.infiniteoptions.toggleInputError(window.Shoppad.$(infiniteSquareFeetInput), false);
      alert('Please fill in the required Square Footage field.');
      return;
    }

    

    const breadcrumbItems = breadcrumbItemsRef.current ?? document.querySelectorAll('.breadcrumb__list .breadcrumb__item');
    const category = breadcrumbItems?.[1]?.querySelector('a')?.textContent ?? null;
    // const category = localStorage.getItem("___ELEVAR_GTM_SUITE--lastCollectionPathname");
    // let collectionList = [];
    // if (category) {
    //   const category_string = category.split('/').pop();
    //   const negative_categories = ['Boost All', 'Developer Playground Equipment', 'Apartment & HOA Playground Equipment', 'Ships Quickly', 'In Stock', 'Daycare Playground Equipment', 'Church Playground Equipment', 'Best Sellers', 'Playgrounds On Sale', 'Quick Ship', 'School Playground Equipment', 'UltraPlay Summer 2021 Sale', 'EduBuild Pros', 'In Stock'];
    //   const collectionScript = document.querySelector('script[data-product-collection-json]');
      
    //   if (collectionScript) {
    //     const collectionJSON = JSON.parse(collectionScript.innerHTML).collections;
    //     collectionList = collectionJSON.filter(category => !negative_categories.includes(category));
    //     if (category_string) {
    //       collectionList.unshift(category_string);
    //     }
    //   }
    // }


    // const productLeadTime = selector.getAttribute('data-product-lead_time');
    // const variantLeadTime = selectedVariant.getAttribute('data-lead_time');

    
    const mainSelector = productForm.querySelector('[id^="product-select-"]');
    const currentItem = mainSelector ? mainSelector.querySelector(`[value="${variant.id}"]`) : null;
    const manual_element = document.getElementById('product-manual');
    const manual_link = manual_element?.getAttribute('href') || currentItem?.getAttribute('data-manual');

    const packing_list_element = document.getElementById('packing-list');
    const packing_list_link = packing_list_element?.getAttribute('href') || null;
    
    

    let { var_img, imgAspectRatio } = product.featured_image ? { var_img: product.featured_image, imgAspectRatio: 1 } : { var_img: variant.featured_media.preview_image.src, imgAspectRatio: variant.featured_media.preview_image.aspect_ratio };

    const var_img_split = var_img.split('?v=')[0];
    const main_image_url = var_img_split.substring(0, var_img_split.lastIndexOf('.')) || var_img_split;
    const extension = var_img_split.split('.').pop();
    const final_image_url = `${main_image_url}_150x.${extension}`;
    const main_image = `${main_image_url}.${extension}`;

    // const filteredTags = filterProductTags(product.tags, ['Update', 'OtherTag']);
    const filteredTags = filterProductTags(product.tags, {
      excludeTags: ['Update', 'NEWPRODUCT', 'update', 'Ready for launch', 'WillyGoat Toys & Playgrounds', '__CC EDIT', 'Maverick', 'Joel Review', 'Joel-Review', 'collection-sale', 'Before launch', 'AI_Image', 'GOCON quote', 'CC EDIT'],
      excludePrefixes: ['__label:', 'Price_', 'Price Bucket_', '__tab', 'organization ', '__PE', '__SP-', '__MS', 'Age Range_', '__SHADE-', 'Certifications_', 'Organization_', 'Swing Count_', '__PIP_', 'Price Range ']
    });
    const quoteOnly = (product.tags.includes('Hide Price') || product.tags.includes('Quote Only')) ? true : false;
    const hasIntegratedShade = product.tags.includes('integrated_shade') ? true : false;
  
    
    // console.log('parent-sku', product.variants[0].sku);
    if (product && variant && product.id && variant.id) {
      let item = {
        id: `${variant.id}::${optionsKey}`,
        quantity: itemQuantity,
        productId: product.id,
        variantId: variant.id,
        price: variantPrice,
        basePrice: base_price,
        url: "/products/" + product.handle + "?variant=" + variant.id,
        handle: product.handle,
        sku: variant.sku,
        options: options,
        title: product.title,
        variantTitle: variant.public_title,
        mainImage: main_image,
        featuredImage: final_image_url,
        compareAtPrice: compare_at_price,
        aspectRatio: imgAspectRatio,
        leadTime: leadTime,
        brand: product.vendor,
        productType: product.type,
        hasIntegratedShade: hasIntegratedShade,
        tags: filteredTags,
        quoteOnly: quoteOnly,
        
        option1: option1,
        option2: option2,
        option3: option3,
        // shopifyOptions: shopify_options,
        category: category,
        // collections: collectionList,
        manual: manual_link ? manual_link : null,
        packingList: packing_list_link ? packing_list_link : null,
        // manuals: manuals,
        // cratingFee: cratingFee ? cratingFee : null,
        cratingFee: product.vendor == 'Playground Equipment' ? parseFloat(cratingFee) : product.vendor == 'Modern Shade' ? cratingFee : null,
        cratingFeeVariant: product.vendor == 'SportsPlay' ? parseFloat(cratingFeeVariant) : null,
        frFabricFee: product.vendor == 'Modern Shade' ? frFabricFee : null,
        parentSKU: product.variants[0].sku ? product.variants[0].sku : null,
        // shopifyId: "shopify_US_" + product.id + "_" + variant.id

        ...((product.type === "Shades" && currentItem) && {
          sh_ins_lab: currentItem?.getAttribute('data-sh_ins_lab'),
          sh_ins_mats: currentItem?.getAttribute('data-sh_ins_mats'),
          sh_ins_eqp: currentItem?.getAttribute('data-sh_ins_eqp')
        })
      };
            
      const foundItem = items.find(i => i.id === item.id);
      
      // If there's a matching item (with the same attributes & options), update the quantity
      foundItem ? updateItem(foundItem, {quantity: foundItem.quantity + item.quantity }) : addItem(item);
      
      setShowMiniQuote(true);
      // setShowModal(true);


      try {
        const personalizationData = localStorage.getItem("Personalization");
        let data = personalizationData ? JSON.parse(personalizationData) : {
          recentlyViewedProducts: [],
          recentlyPurchasedProducts: [],
          recentlyAddedToCartProducts: []
        };
        
        // Add product ID to recentlyAddedToCartProducts if not already present
        if (!data.recentlyAddedToCartProducts.includes(product.id)) {
          data.recentlyAddedToCartProducts.push(product.id);
          localStorage.setItem("Personalization", JSON.stringify(data));
        }
      } catch (error) {
        console.error("Error updating recentlyAddedToCartProducts:", error);
      }
      
      // console.log('sku', variant.sku);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          event: 'rfq_add_to_quote',
          add_to_quote_id: quoteId,
          add_to_quote_product_price: variantPrice / 100,
          add_to_quote_product_title: product.title, 
          add_to_quote_product_name: product.title + ' - ' + variant.public_title,
          add_to_quote_variant_title: variant.public_title,
          add_to_quote_product_id: product.id,
          add_to_quote_variant_id: variant.id,
          add_to_quote_vendor: product.vendor,
          add_to_quote_variant_sku: variant.sku,
          add_to_quote_product_quantity: itemQuantity,
          add_to_quote_product_options: options,
          add_to_quote_total_value: totalPrice > 0 ? totalPrice / 100 : variantPrice / 100,
          add_to_quote_product_url: "/products/" + product.handle + "?variant=" + variant.id,
          add_to_quote_shopify_id: "shopify_US_" + product.id + "_" + variant.id,
          add_to_quote_product_image: product.featured_image,
          currency: 'USD',
          // add_to_quote_categories: collectionList,
          add_to_quote_product_type: product.type,
          // add_to_quote_manual: manual_link,
          add_to_quote_items: ecommerce_items(),
          ecommerce: {
            currencyCode: 'USD',
            add: {
              actionField: {
                list: category
              },
              products: [
                ecommerce_items()
              ]
            }
          }
      });


      

      
      if(window.ElevarDataLayer){
        window.ElevarDataLayer.push({
          event: "dl_add_to_cart",
          ecommerce: {
            currencyCode: 'USD',
            add: {
              actionField: {
                list: category
              },
              products: [
                ecommerce_items()
              ]
            }
          }
        })
      }

      function ecommerce_items() {
        return {
          // id: "shopify_US_" + product.id + "_" + variant.id,
          id: variant.sku,
          product_id: product.id.toString(),
          variant_id: variant.id.toString(),
          brand: product.vendor,
          price: (variantPrice / 100).toString(),
          quantity: itemQuantity.toString(),
          name: product.title,
          variant: variant.public_title,
          list: category,
          category: product.type,
          // compare_at_price: compare_at_price,
          ...compare_at_price ? {compare_at_price: compare_at_price.toString()} : {},
          image: product.featured_image,
          sku: variant.sku,
          google_business_vertical: 'retail',
        }
      }


 

      let learnq = window._learnq || [];
      const klaviyo_item = {
        "Name": product.title,
        "ProductName": product.title,
        "ProductID": product.id,
        "VaritantID": variant.id,
        "VariantTitle": variant.public_title,
        "Tags": product.tags,
        "ImageURL": product.featured_image,
        "URL": "/products/" + product.handle + "?variant=" + variant.id,
        "ProductBrand": product.vendor,
        "Brand": product.vendor,
        "Price": variantPrice / 100,
        "CompareAtPrice": compare_at_price,
        "SKU": variant.sku,
        "Type": product.type,
        // "Categories": collectionList,
        "QuoteID": quoteId,
        // "Manual": manual_link,
      };
      learnq.push(['track', 'Added to Quote', klaviyo_item]);


      // event: "rfq_add_to_quote",
      //   event_id: e.eventId,
      //   ecommerce: {
      //     currencyCode: e.currencyCode,
      //     remove: {
      //       actionField: {
      //         list: e.item.list
      //       },
      //       products: [{
      //         id: e.item.id,
      //         name: e.item.name,
      //         brand: e.item.brand,
      //         category: e.item.category,
      //         variant: e.item.variant,
      //         price: e.item.price,
      //         quantity: e.item.quantity,
      //         list: e.item.list,
      //         product_id: e.item.productId,
      //         variant_id: e.item.variantId,
      //         image: e.item.image
      //       }]
      //     }
      //   }
      
    } else {
      // handle error
    }

  }, [quoteId, quoteQuantity, variant, product, items, totalPrice, addItem, updateItem, setShowMiniQuote]);

  if (product.tags.includes("Quote Required") || product.tags.includes("Quote Optional")) {
    return (
      <>
        {/* <button id="addToQuoteBtn" className={`button ${!product.available? "button--disabled": "button--primary"}`} style={{ width: buttonWidth }} style={{width: "100%"}} onClick={handleAddToQuote} disabled={!product.available? true: false}></button> */}
        <button id="addToQuoteBtn" className={`button ${!product.available? "button--disabled": "button--primary"}`} style={{ width: buttonWidth }} onClick={handleAddToQuote} disabled={!product.available? true: false}>
          Add to Quote { itemQuantity > 1 ? `(${itemQuantity})` : '' }
        </button>
      </>
    );
  } else {
    return null;
  }
};
